<template>
    <div class="quickpay-recommendation">
        <div class="quickpay-recommendation__illustration">
            <img
                :src="provider.recommendation.banner"
                :alt="provider.name"
                class="quickpay-recommendation__banner-logo"
            />
        </div>
        <div class="quickpay-recommendation__content">
            <CompassPill
                :label="$t.__('quickpay.settings.recommendation.tag')"
                :variant="CompassEnums.PillVariant.PASTEL"
                :color="CompassEnums.PillColor.TEAL"
                :size="CompassEnums.PillSize.EXTRA_SMALL"
            />
            <p class="quickpay-recommendation__title typographies-paragraph-medium-regular">
                {{ $t.__(provider.recommendation.titleKey) }}
            </p>
            <ul class="quickpay-recommendation__bullets">
                <li
                    v-for="(bulletKey, index) in provider.recommendation.bullets"
                    :key="index"
                    class="quickpay-recommendation__bullet"
                >
                    <CompassIcon icon="success-circle-fill" :size="CompassEnums.IconSize.SMALL" />
                    <span class="typographies-paragraph-medium-regular">
                        {{ $t.__(bulletKey) }}
                    </span>
                </li>
            </ul>
            <CompassButton
                :label="$t.__(provider.recommendation.ctaKey)"
                :type="CompassEnums.ButtonType.PRIMARY"
                class="quickpay-recommendation__cta"
                @click="emit('connect', provider.id)"
            />
        </div>
        <CompassIconButton
            class="quickpay-recommendation__close"
            icon="close"
            size="small"
            @click="emit('dismiss')"
        />
    </div>
</template>

<script setup>
import { inject } from 'vue';

defineProps({
    provider: {
        type: Object,
        required: true,
    },
});

const emit = defineEmits(['dismiss', 'connect']);

const $t = inject('$t');
</script>

<style lang="scss" scoped>
.quickpay-recommendation {
    min-height: 216px;
    display: flex;
    gap: var(--spacing-3);
    border: 1px solid var(--colors-common-border-darkest);
    border-radius: var(--spacing-1);
    overflow: hidden;
    position: relative;
    margin-bottom: var(--spacing-4);
    &__illustration {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        overflow: hidden;
    }
    &__banner-logo {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.5s ease-in-out;
    }
    &:hover &__banner-logo {
        transform: scale(1.10);
    }
    &__content {
        flex: 1;
        padding: 22px var(--spacing-6);
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: var(--spacing-2);
    }
    &__title {
        margin: 0;
        color: var(--colors-common-text-standard-default);
    }
    &__bullets {
        list-style: none;
        padding: 0;
        margin: 0;
        display: flex;
        flex-direction: column;
        gap: var(--spacing-0);
    }
    &__bullet {
        display: flex;
        align-items: center;
        gap: var(--spacing-0);
        color: var(--colors-common-text-standard-default);
    }
    &__cta {
        align-self: stretch;
    }
    &__close {
        position: absolute;
        top: var(--spacing-0);
        right: var(--spacing-0);
    }
}
</style>
